import { Box } from '@mui/material';
import { useFragment } from '../../hooks/useFragment';
import { FragmentSocialPublishView } from './FragmentSocialPublishView';
import { FragmentDeliveryStatus } from './external-export/FragmentDeliveryStatus';

/**
 * Export "Publish" tab content: social platforms and external export.
 */
export function FragmentPublishView() {
  const { fragment } = useFragment();

  return (
    <Box sx={{ maxWidth: 'md' }}>
      <FragmentSocialPublishView />
      <Box mt={4}>{fragment.mediaCompletedAt ? <FragmentDeliveryStatus /> : null}</Box>
    </Box>
  );
}
